<script lang="ts">
	import { get } from 'svelte/store';
	import { page } from '$app/stores';
	import type { EmployeeListBlock } from './EmployeeListBlockQuery';
	import { Employee, Headline } from '@atoms';
	import { PathUtils } from '@core/tools/PathUtils';
	import { createViewController, ViewController } from '$lib/actions/animations/ViewController';
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';

	const { data }: { data: EmployeeListBlock } = $props();
	const employees = get(page).data.globals.allEmployees;

	createViewController();
</script>

<section id={PathUtils.slugify(data.headline)} use:ViewController>
	<div class="headline" use:EnterOnView>
		<Headline borderTop={true} text={data.headline} />
	</div>

	<div class="container">
		{#each employees as employee, i}
			<div class="employee" use:EnterOnView={{ delay: i * 0.1 }}>
				<Employee {...employee}></Employee>
			</div>
		{/each}
	</div>
</section>

<style lang="scss">
	section {
		@include pagePadding;
		@include blockPadding;

		@include md {
			&:target {
				scroll-margin-top: 94px;
			}
		}
	}

	.headline {
		@include layoutBlockGrid(false);
		:global(.container) {
			grid-column: 1 / -1;
		}
	}

	.container {
		@include layoutBlockGrid(false);
		.employee {
			grid-column: span 2;
			@include md {
				grid-column: span 3;
			}
		}
	}
</style>
